import React from 'react';
import { useQuery } from 'react-query';
import { getParticipation } from '../../../service';
import ParticipationContent from '../ParticipationContent';

type Props = {
  term: string;
  slug: any;
};

function ParticipationContentList({ term, slug }: Props) {

  const { isLoading, error, data } = useQuery('ParticipationContent', () => getParticipation(`${term}${slug}`));

  return (
    <>
    {
      !isLoading && !error && data && (
       <>
          {
            data.map((item:any, index:number) => (
              <ParticipationContent key={index} term={term} slug={slug} data={item} />
            ))
        }
      </>
      )
    }
    </>
  );
}

ParticipationContentList.defaultProps = {
};

export default ParticipationContentList;
